import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "../UI/Button";
import Logo from "../../assets/Autograph-logo-01 1.svg";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Animate navbar on mount
    const timer = setTimeout(() => setIsVisible(true), 100);
    
    // Handle scroll for navbar background effect
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`shadow-sm py-4 sm:py-6 md:py-8 lg:py-12 xl:py-14 2xl:py-16 transition-all duration-500 ${
      isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
    }`}>
      <div className={`bg-ag-black-800 max-w-2xl border-[0.1px] border-ag-black-600 w-[95%] sm:w-[85%] md:w-[70%] lg:w-[55%] xl:w-[50%] 2xl:w-[45%] rounded-xl mx-auto px-3 sm:px-4 lg:px-4 2xl:px-0 transition-all duration-300 ${
        scrolled ? "shadow-lg shadow-black/50 border-ag-green/20" : ""
      }`}>
        <div className="flex justify-between sm:justify-center py-2 items-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-12">
          <div className="flex items-center space-x-2 sm:space-x-4 md:space-x-6">
            <img 
              src={Logo} 
              alt="Logo" 
              className="h-6 sm:h-8 md:h-9 lg:h-10 w-auto hover:scale-110 transition-transform duration-300 cursor-pointer"
            />
          </div>
          
          {/* Mobile menu button with animation */}
          <button 
            className="sm:hidden text-white p-2 hover:text-ag-green transition-colors duration-300"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg 
              className={`w-6 h-6 transition-transform duration-300 ${mobileMenuOpen ? 'rotate-90' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Desktop navigation with hover effects */}
          <div className="hidden sm:flex items-center space-x-2 md:space-x-3 lg:space-x-4">
            <Link to="/templates">
              <Button
                className="w-full sm:w-auto text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl hover:scale-105 transition-transform duration-300 btn-press"
                variant="special"
              >
                Demo Now
              </Button>
            </Link>
            <Link
              to="/login"
              className="bg-black px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-[6px] md:py-[8px] text-white text-sm md:text-base lg:text-lg xl:text-xl font-medium hover:text-ag-green rounded-lg transition-all duration-300 hover:bg-ag-black-700 relative overflow-hidden group"
            >
              <span className="relative z-10">Log in</span>
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
            </Link>
          </div>
        </div>

        {/* Mobile menu dropdown with slide animation */}
        <div className={`sm:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
        }`}>
          <div className="py-4 border-t border-ag-black-600 flex flex-col gap-3">
            <Link to="/templates" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full text-sm btn-press" variant="special">
                Demo Now
              </Button>
            </Link>
            <Link
              to="/login"
              className="bg-black px-4 py-2 text-white text-sm font-medium hover:text-ag-green rounded-lg text-center transition-colors duration-300"
              onClick={() => setMobileMenuOpen(false)}
            >
              Log in
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
